import React, { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { prop } from 'ramda';

import { useDeviceSelector } from '@core/js/store/hooks';

import useGetBingoControls from '@interlayer/js/custom/components/main/BingoScheduler/hooks/useGetBingoControls';
import { selectBingoScheduleGames } from '@interlayer/js/custom/components/main/BingoScheduler/store/selectors';

import { BingoSchedulerItem } from './BingoSchedulerItem';

interface Props {
    mergedStyles: Record<string, any>;
    lobbyName: string;
}

const BingoSchedulerList: FC<Props> = ({ mergedStyles, lobbyName }) => {
    const bingoListRef = useRef<HTMLUListElement>(null);
    const formFactor = useDeviceSelector(prop('formFactor'));

    const bingoScheduleGames = useSelector(selectBingoScheduleGames);

    const buttonStyle = mergedStyles.bingo_controls__button;
    const isTouchDevice = formFactor === 'tablet' || formFactor === 'mobile';

    const {
        prevClickHandler, nextClickHandler, onMouseDownHandler, onMouseMoveHandler,
        currentPosition, setCurrentPosition, isLastView
    } = useGetBingoControls({ bingoListRef });

    return (
        <>
            <div className={mergedStyles.bingo_scheduler}>
                <ul
                    className={mergedStyles.bingo_scheduler__list}
                    ref={bingoListRef}
                    onMouseDown={isTouchDevice ? undefined : onMouseDownHandler}
                    onMouseMove={isTouchDevice ? undefined : onMouseMoveHandler}
                >
                    {(bingoScheduleGames ?? []).map((item, index) => (
                        <BingoSchedulerItem
                            key={`${index}_${item.gameCode}_${item.drawTime}`}
                            style={mergedStyles}
                            listData={{ bingoListRef, isLastView, setCurrentPosition }}
                            lobbyName={lobbyName}
                            {...item}
                        />
                    ))}
                </ul>
            </div>

            {!isTouchDevice && (
                <div className={mergedStyles.bingo_controls}>
                    <button
                        type="button"
                        className={`${buttonStyle} ${mergedStyles.bingo_controls__prev} ${
                            !currentPosition ? mergedStyles.is_disable : ''
                        }`}
                        onClick={prevClickHandler}
                        data-qa-tag="bingo-prev-button"
                    />

                    <button
                        type="button"
                        className={`${buttonStyle} ${mergedStyles.bingo_controls__next} ${
                            isLastView ? mergedStyles.is_disable : ''
                        }`}
                        onClick={nextClickHandler}
                        data-qa-tag="bingo-next-button"
                    />
                </div>
            )}
        </>
    );
};

export default BingoSchedulerList;
